module.exports = __webpack_public_path__ + "static/img/mark.45d078e3.png";